import { render } from "./new-password.vue?vue&type=template&id=789f93c4&scoped=true"
import script from "./new-password.vue?vue&type=script&lang=js"
export * from "./new-password.vue?vue&type=script&lang=js"

import "./new-password.vue?vue&type=style&index=0&id=789f93c4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789f93c4"]])

export default __exports__